// extracted by mini-css-extract-plugin
export var atiDocs = "ati-docs__T8Va";
export var cityRating = "city-rating__I4tW";
export var confirmedContacts = "confirmed-contacts__tJpQ";
export var countryRating = "country-rating__ULbz";
export var epdBadge = "epd-badge___FzR";
export var icons = "icons__IF6t";
export var orders = "orders__luBq";
export var realTrucker = "real-trucker__XyxL";
export var reputationSignal = "reputationSignal__tFmM";
export var stars = "stars__jn3v";
export var trafficlight = "trafficlight__bNVH";